<script>
  import ProjectGallery from './project-gallery/ProjectGallery.svelte'
  import ProjectInfo from './project-info/ProjectInfo.svelte'
  import { projectDetail } from '../../../store'
  import { PROJECT_STATUSES } from '../../../constants/constants'
  let backButton = './images/back-arrow.svg'
  export let saleCardDetails, sale, token, reserve, saleData, projectTierData

</script>

<div class="back-project">
  <a href="javascript:void(0)" id="back-history-page" onclick="history.back()" class="flex items-center">
    <img src={backButton} alt="backButton" />
    <p>Go Back Projects</p>
  </a>
</div>
<header class="gallery-header flex items-center">
  <div class="flex-1">
    <h2>{$projectDetail.project_name ?? ""}</h2>
    <p>{$projectDetail.project_description ?? ""}</p>
  </div>
  <div class="ml-auto flex items-center">
    {#if $projectDetail.sale_address}
    <span class="detail_tier">{projectTierData ? projectTierData.tier_label : "Public"}</span>
    {/if}
    {#if $projectDetail.project_status}
    <div
      class={`tier-badge-btn ${$projectDetail.project_status.toLowerCase()}`}>
      {$projectDetail.project_status === PROJECT_STATUSES.LIVE ? 'Live' : $projectDetail.project_status}
    </div>
    {/if}
  </div>
</header>
<div class="visual flex">
  {#if $projectDetail.project_cover}
    <ProjectGallery img={$projectDetail.project_cover} {projectTierData} />
  {/if}
  <ProjectInfo
    {projectTierData}
    {saleData}
    {sale}
    {reserve}
    {token}
    {saleCardDetails} />
</div>
